export const DATEFILTER = {
  MIN: "StartDate",
  MAX: "EndDate",
  DATE1: "Date",
  DATE2: "date",
  TIME: "Time",
  All: "all",
  SEARCH: "search"
};
